import React from 'react';
import { Link } from 'react-router';
import Fold from '../Fold';
import handsImage from './assets/hands.png';
import hustleImage from './assets/hustle.png';
import styles from './styles.scss';

function FoldHome() {
  return (
    <Fold bgStyle={`#f7f7f7 url(${handsImage}) bottom right no-repeat`}>
      <h1 className={`${styles.heading} bold extra-bold`}>
        Hire designers to <img src={hustleImage} className={styles.hustle} alt="hustle" />
        for your startup
      </h1>
      <h2 className={`${styles.subHeading} mt30 mb30 alt-text light-italics`}>
        Whether you need an app or website designed, we’ve got the talent for you.
      </h2>
      <Link to="/get-started" className={`btn btn-dc-blue mb150 ${styles.briefButton}`}>
        SUBMIT A BRIEF
      </Link>
    </Fold>
  );
}

export default FoldHome;



// WEBPACK FOOTER //
// ./src/components/FoldHome/index.js